import React from 'react'
import { IconWrapperStyled } from '@mobi/sports-offering/Components/Common/Common.styles'
import { TeamColor } from '../../TeamIcon/Components/types'

export const TeamShieldColorsIcon: React.FC<{
  size: string
  colors: TeamColor
}> = ({ size, colors }) => {
  return (
    <IconWrapperStyled style={{ width: size, height: size }}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 48 48'
        fill='none'
      >
        <path d='M0 48V0H48L0 48Z' fill={colors.mainColor} />
        <path d='M0 48L48 0V48H0Z' fill={colors.secondaryColor} />
      </svg>
    </IconWrapperStyled>
  )
}
